import React, { useEffect, useState } from 'react';
import axios from 'axios'
import "./Home.css"
import { useAuthContext } from '../../context/AuthContext';
import HomeHeader from './components/HomeHeader';
import GroupComponent from './components/GroupComponent';
import { API_BASE_URL } from '../../config/api';

let baseURL = API_BASE_URL;

const Home = () => {
    const [profGroups, setProfGroups] = useState([])
    const {authUser} = useAuthContext(); 

    useEffect(() => {
        if (authUser) { 
            console.log("logged in user:", authUser.profName)
            fetchGroups()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authUser])
    
    useEffect(() => {
        console.log('Updated Prof groups:', profGroups);
    }, [profGroups]);
    
    const fetchGroups = async () => {
        try{ 
            const response = await axios.get(`${baseURL}/api/group/${authUser._id}/groups`)
            console.log('response', response.data.groups)
            setProfGroups(response.data.groups)
        } catch(error) { 
            console.error('Error fetching professor groups: ', error)
        }
    }



    const createGroup = async (groupName) => {
        try {
            const response = await axios.post(`${baseURL}/api/group/${authUser._id}/groups`, groupName);
            console.log('New group added:', response.data);
            setProfGroups(prevGroups => [...prevGroups, response.data]);
            return response.data; // Return the created group data
        } catch (error) { 
            console.error('Error creating new group: ', error);
            return null; // Return null on error
        }
    }

    return (
        <div>
            <HomeHeader className="header"/>
            <GroupComponent className="group" professor={authUser} groups={profGroups} createGroup={createGroup}/>
        </div>
    )
}

export default Home